import type { novaToolDefs } from '@newfront-insurance/ai-api';
import type { InferUITool, ToolUIPart } from 'ai';

import { GeneratedFilesList } from './process-files-tool';

type FillSl2FormOutput = InferUITool<(typeof novaToolDefs)['fillSl2Form']>['output'];

interface FillSl2FormToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering fillSl2Form tool output.
 */
export function FillSl2FormTool({ part }: FillSl2FormToolProps) {
  if (part.state !== 'output-available') return null;

  const output = part.output as FillSl2FormOutput;
  if (output?.generatedFileUuids) {
    return (
      <GeneratedFilesList
        files={output.generatedFileUuids.map((uuid, idx) => ({ uuid, filename: `SL2 form ${idx + 1}.pdf` }))}
      />
    );
  }

  return null;
}
